var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#D3D6DE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9412 19C30.6544 19 29.7353 20.011 29.7353 21.2059V32.9706C29.7353 34.2574 30.6544 35.1765 31.9412 35.1765C33.136 35.1765 34.1471 34.2574 34.1471 32.9706V21.2059C34.1471 20.011 33.136 19 31.9412 19ZM29 41.1507C29 42.7132 30.2868 44 31.9412 44C33.5037 44 34.7904 42.7132 34.7904 41.1507C34.7904 39.5882 33.5037 38.3015 31.9412 38.3015C30.2868 38.3015 29 39.5882 29 41.1507Z",
    fill: "#284254"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.919048f1e01aff26b7f4768a22e4227c.svg";
export { ForwardRef as ReactComponent };